// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!../fonts/webfontkit-AleofontSans/stylesheet.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* import fonts/style.css */

body {
  padding: 0;
  margin: 0;
  background-color: #121212;
  color: #f5f5f5;
  font-family: 'aleofont_sansregular', sans-serif;
}
.aleo-font {
  font-family: 'aleofont_sansregular', sans-serif;
  text-transform: uppercase;
}
a {
  color: #f5f5f5;
  text-decoration: none;
}

.content-list {
  max-width: 90%;
  font-size: 32px;
  text-align: center;
}
.instructions-list div {
  margin-bottom: 10px;
  text-transform: uppercase;
}
.instructions-list div span {
  margin-right: 10px;
}
.vertical-form {
  display: flex;
  flex-direction: column;
  padding-top: 20px;
}
.subheading {
  font-size: 20px;
  letter-spacing: 10px;
  text-align: center;
  text-transform: uppercase;
}
.prompt {
  font-size: 32px;
  letter-spacing: 1.6px;
  text-align: center;
  line-height: 135%;
  margin-top: 60px;
  margin-bottom: 60px;
  text-transform: uppercase;
  text-align: center;
  max-width: 1000px;
}
.gradient-text {
  background: linear-gradient(
    90deg,
    #c4ffc2 4.84%,
    #ffe092 34.12%,
    #ffe2fc 67.12%,
    #eeffa8 91.67%
  );
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.sub-nav {
  display: flex;
  align-items: center;
  margin-bottom: 64px;
  width: 100%;
  justify-content: space-evenly;
}
.sub-nav .center-nav {
  width: 33.33%;
}
.sub-nav .left-nav {
  display: flex;
  justify-content: flex-start;
  width: 33.33%;
}
.sub-nav .left-nav:hover {
  background: linear-gradient(
    90deg,
    #c4ffc2 4.84%,
    #ffe092 34.12%,
    #ffe2fc 67.12%,
    #eeffa8 91.67%
  );
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.sub-nav .back {
  margin-left: 12px;
  font-size: 20px;
  line-height: 16px;
}
.sub-nav .right-nav {
  display: flex;
  justify-content: flex-end;
  width: 33.33%;
  visibility: hidden;
}
.decrypt-instructions {
  text-align: center;
  color: #757575;
  font-size: 14px;
  line-height: 135%;
  letter-spacing: 0.7px;
  margin: 16px 0;
}

.aleo-textarea :hover {
  cursor: pointer;
}

/* Button Component */
.cta-button {
  background: #2e2e2e;
  color: #f5f5f5;
  cursor: pointer;
}
.cta-button:hover {
  background: linear-gradient(
    90deg,
    #c4ffc2 4.84%,
    #ffe092 34.12%,
    #ffe2fc 67.12%,
    #eeffa8 91.67%
  );
  color: #121212 !important;
  border-color: transparent !important;
}
.cta-button[disabled] {
  background: #2e2e2e;
  color: #f5f5f5;
  cursor: not-allowed;
  opacity: 0.5;
  border-color: #f5f5f5 !important;
}
.cta-button[disabled]:hover {
  background: #2e2e2e !important;
  color: #f5f5f5 !important;
  cursor: not-allowed !important;
  opacity: 0.5;
}
.action-buttons {
  display: flex;
  justify-content: space-evenly;
  margin-top: 20px;
}

/* Toolkit Page */
.content-blocks .content-block a {
  color: inherit;
}
.content-blocks .content-block:hover {
  background: linear-gradient(
    90deg,
    #c4ffc2 4.84%,
    #ffe092 34.12%,
    #ffe2fc 67.12%,
    #eeffa8 91.67%
  );
  color: #121212 !important;
  border-color: transparent !important;
}
/* Header Page*/
.nav-link:hover {
  background: linear-gradient(
    90deg,
    #c4ffc2 4.84%,
    #ffe092 34.12%,
    #ffe2fc 67.12%,
    #eeffa8 91.67%
  );
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.nav-item {
  border-bottom: solid 1px transparent;
}
.nav-item:hover {
  border-bottom: solid 1px #f5f5f5;
}
.nav-item:active {
  border-bottom: solid 1px #f5f5f5;
}
.nav-item.active-link {
  border-bottom: solid 1px #f5f5f5;
}
/* Layout */
.layout-content {
  display: flex;
  margin: 0;
  padding-bottom: 120px;
}

/* Leaderboard */
.table-leaderboard {
  width: 100%;
  max-width: 100%;
  margin-bottom: 60px;
  text-transform: uppercase;
  /* background-color: pink; */
}

.table-leaderboard thead tr {
  height: 48px;
}
.table-leaderboard th {
  color: #757575;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 135%; /* 18.9px */
  letter-spacing: 0.7px;
  text-transform: uppercase;
}

.table-leaderboard tbody tr {
  border-bottom: solid 1px #f5f5f5;
  height: 64px;
  font-size: 22px;
  line-height: 135%;
  letter-spacing: 1.6px;
  border-spacing: 0px;
}

.table-leaderboard tbody tr td {
  border-bottom: solid 1pt #f5f5f5;
  /* padding-bottom: 5px; */
  border-spacing: 0px;
  border-collapse: collapse;
}
/* Footer */
.footer-link:hover {
  background: linear-gradient(
    90deg,
    #c4ffc2 4.84%,
    #ffe092 34.12%,
    #ffe2fc 67.12%,
    #eeffa8 91.67%
  );
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

/* Code Block */
pre {
  background-color: #2e2e2e;
  color: #f5f5f5;
  padding: 20px;
  border-radius: 4px;
  font-size: 12px;
  line-height: 135%;
  letter-spacing: 0.7px;
  margin-top: 10px;
  overflow-x: auto;
}

.translator-hint {
  font-size: 14px;
}

/* Media Queries */
@media (max-width: 1280px) {
  .table-leaderboard tbody tr {
    font-size: 16px;
  }
  .layout-content {
    margin: 0 0px;
  }
}

@media (max-width: 1020px) {
  .enigma-header {
    flex-direction: column;
  }
  .enigma-header ul {
    margin-top: 24px;
    gap: 0 24px !important;
  }
}

@media (max-width: 900px) {
  .table-leaderboard tbody tr {
    font-size: 10px;
    margin: 0 0px;
  }
}

@media (max-width: 730px) {
  .enigma-header ul {
    gap: 0 18px !important;
  }
  .enigma-header ul li {
    font-size: 16px !important;
  }
}

@media (max-width: 700px) {
  .table-leaderboard tbody tr {
    font-size: 9px;
  }
  .layout-content {
    margin: 0 0px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAAA,2BAA2B;;AAG3B;EACE,UAAU;EACV,SAAS;EACT,yBAAyB;EACzB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,+CAA+C;EAC/C,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE;;;;;;GAMC;EACD,qBAAqB;EACrB,6BAA6B;EAC7B,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,6BAA6B;AAC/B;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,aAAa;AACf;AACA;EACE;;;;;;GAMC;EACD,qBAAqB;EACrB,6BAA6B;EAC7B,oCAAoC;AACtC;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA;EACE;;;;;;GAMC;EACD,yBAAyB;EACzB,oCAAoC;AACtC;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,gCAAgC;AAClC;AACA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,8BAA8B;EAC9B,YAAY;AACd;AACA;EACE,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,cAAc;AAChB;AACA;EACE;;;;;;GAMC;EACD,yBAAyB;EACzB,oCAAoC;AACtC;AACA,eAAe;AACf;EACE;;;;;;GAMC;EACD,qBAAqB;EACrB,6BAA6B;EAC7B,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA,WAAW;AACX;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,YAAY;AACd;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,WAAW;EAC9B,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA,WAAW;AACX;EACE;;;;;;GAMC;EACD,qBAAqB;EACrB,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA,eAAe;AACf;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,eAAe;IACf,aAAa;EACf;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;AACF","sourcesContent":["/* import fonts/style.css */\n@import url('../fonts/webfontkit-AleofontSans/stylesheet.css');\n\nbody {\n  padding: 0;\n  margin: 0;\n  background-color: #121212;\n  color: #f5f5f5;\n  font-family: 'aleofont_sansregular', sans-serif;\n}\n.aleo-font {\n  font-family: 'aleofont_sansregular', sans-serif;\n  text-transform: uppercase;\n}\na {\n  color: #f5f5f5;\n  text-decoration: none;\n}\n\n.content-list {\n  max-width: 90%;\n  font-size: 32px;\n  text-align: center;\n}\n.instructions-list div {\n  margin-bottom: 10px;\n  text-transform: uppercase;\n}\n.instructions-list div span {\n  margin-right: 10px;\n}\n.vertical-form {\n  display: flex;\n  flex-direction: column;\n  padding-top: 20px;\n}\n.subheading {\n  font-size: 20px;\n  letter-spacing: 10px;\n  text-align: center;\n  text-transform: uppercase;\n}\n.prompt {\n  font-size: 32px;\n  letter-spacing: 1.6px;\n  text-align: center;\n  line-height: 135%;\n  margin-top: 60px;\n  margin-bottom: 60px;\n  text-transform: uppercase;\n  text-align: center;\n  max-width: 1000px;\n}\n.gradient-text {\n  background: linear-gradient(\n    90deg,\n    #c4ffc2 4.84%,\n    #ffe092 34.12%,\n    #ffe2fc 67.12%,\n    #eeffa8 91.67%\n  );\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n.sub-nav {\n  display: flex;\n  align-items: center;\n  margin-bottom: 64px;\n  width: 100%;\n  justify-content: space-evenly;\n}\n.sub-nav .center-nav {\n  width: 33.33%;\n}\n.sub-nav .left-nav {\n  display: flex;\n  justify-content: flex-start;\n  width: 33.33%;\n}\n.sub-nav .left-nav:hover {\n  background: linear-gradient(\n    90deg,\n    #c4ffc2 4.84%,\n    #ffe092 34.12%,\n    #ffe2fc 67.12%,\n    #eeffa8 91.67%\n  );\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n.sub-nav .back {\n  margin-left: 12px;\n  font-size: 20px;\n  line-height: 16px;\n}\n.sub-nav .right-nav {\n  display: flex;\n  justify-content: flex-end;\n  width: 33.33%;\n  visibility: hidden;\n}\n.decrypt-instructions {\n  text-align: center;\n  color: #757575;\n  font-size: 14px;\n  line-height: 135%;\n  letter-spacing: 0.7px;\n  margin: 16px 0;\n}\n\n.aleo-textarea :hover {\n  cursor: pointer;\n}\n\n/* Button Component */\n.cta-button {\n  background: #2e2e2e;\n  color: #f5f5f5;\n  cursor: pointer;\n}\n.cta-button:hover {\n  background: linear-gradient(\n    90deg,\n    #c4ffc2 4.84%,\n    #ffe092 34.12%,\n    #ffe2fc 67.12%,\n    #eeffa8 91.67%\n  );\n  color: #121212 !important;\n  border-color: transparent !important;\n}\n.cta-button[disabled] {\n  background: #2e2e2e;\n  color: #f5f5f5;\n  cursor: not-allowed;\n  opacity: 0.5;\n  border-color: #f5f5f5 !important;\n}\n.cta-button[disabled]:hover {\n  background: #2e2e2e !important;\n  color: #f5f5f5 !important;\n  cursor: not-allowed !important;\n  opacity: 0.5;\n}\n.action-buttons {\n  display: flex;\n  justify-content: space-evenly;\n  margin-top: 20px;\n}\n\n/* Toolkit Page */\n.content-blocks .content-block a {\n  color: inherit;\n}\n.content-blocks .content-block:hover {\n  background: linear-gradient(\n    90deg,\n    #c4ffc2 4.84%,\n    #ffe092 34.12%,\n    #ffe2fc 67.12%,\n    #eeffa8 91.67%\n  );\n  color: #121212 !important;\n  border-color: transparent !important;\n}\n/* Header Page*/\n.nav-link:hover {\n  background: linear-gradient(\n    90deg,\n    #c4ffc2 4.84%,\n    #ffe092 34.12%,\n    #ffe2fc 67.12%,\n    #eeffa8 91.67%\n  );\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n.nav-item {\n  border-bottom: solid 1px transparent;\n}\n.nav-item:hover {\n  border-bottom: solid 1px #f5f5f5;\n}\n.nav-item:active {\n  border-bottom: solid 1px #f5f5f5;\n}\n.nav-item.active-link {\n  border-bottom: solid 1px #f5f5f5;\n}\n/* Layout */\n.layout-content {\n  display: flex;\n  margin: 0;\n  padding-bottom: 120px;\n}\n\n/* Leaderboard */\n.table-leaderboard {\n  width: 100%;\n  max-width: 100%;\n  margin-bottom: 60px;\n  text-transform: uppercase;\n  /* background-color: pink; */\n}\n\n.table-leaderboard thead tr {\n  height: 48px;\n}\n.table-leaderboard th {\n  color: #757575;\n  text-align: center;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 135%; /* 18.9px */\n  letter-spacing: 0.7px;\n  text-transform: uppercase;\n}\n\n.table-leaderboard tbody tr {\n  border-bottom: solid 1px #f5f5f5;\n  height: 64px;\n  font-size: 22px;\n  line-height: 135%;\n  letter-spacing: 1.6px;\n  border-spacing: 0px;\n}\n\n.table-leaderboard tbody tr td {\n  border-bottom: solid 1pt #f5f5f5;\n  /* padding-bottom: 5px; */\n  border-spacing: 0px;\n  border-collapse: collapse;\n}\n/* Footer */\n.footer-link:hover {\n  background: linear-gradient(\n    90deg,\n    #c4ffc2 4.84%,\n    #ffe092 34.12%,\n    #ffe2fc 67.12%,\n    #eeffa8 91.67%\n  );\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n/* Code Block */\npre {\n  background-color: #2e2e2e;\n  color: #f5f5f5;\n  padding: 20px;\n  border-radius: 4px;\n  font-size: 12px;\n  line-height: 135%;\n  letter-spacing: 0.7px;\n  margin-top: 10px;\n  overflow-x: auto;\n}\n\n.translator-hint {\n  font-size: 14px;\n}\n\n/* Media Queries */\n@media (max-width: 1280px) {\n  .table-leaderboard tbody tr {\n    font-size: 16px;\n  }\n  .layout-content {\n    margin: 0 0px;\n  }\n}\n\n@media (max-width: 1020px) {\n  .enigma-header {\n    flex-direction: column;\n  }\n  .enigma-header ul {\n    margin-top: 24px;\n    gap: 0 24px !important;\n  }\n}\n\n@media (max-width: 900px) {\n  .table-leaderboard tbody tr {\n    font-size: 10px;\n    margin: 0 0px;\n  }\n}\n\n@media (max-width: 730px) {\n  .enigma-header ul {\n    gap: 0 18px !important;\n  }\n  .enigma-header ul li {\n    font-size: 16px !important;\n  }\n}\n\n@media (max-width: 700px) {\n  .table-leaderboard tbody tr {\n    font-size: 9px;\n  }\n  .layout-content {\n    margin: 0 0px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
